import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getQuickReply, uploadFileInChat } from "../../reducers/commonReducer";
const animatedComponents = makeAnimated();

const schema = yup.object().shape({
  title: yup.string().required(),
  orderBy: yup.string().required(),
  branch: yup.array().nullable(),
});
function QuickReplyAction(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const isTeamLeader = localStorage.getItem("slug") === "team_leader";
  const handleClose = () => setShow(false);
  const {
    popupTitle,
    api,
    title,
    question,
    messageType,
    content,
    orderBy,
    branch,
    id,
    buttonTitle,
    suggestionfile,
    status,
    files,
  } = props;

  const handleShow = () => {
    setExistingFiles(files || []);
    setSelectedFiles([]);
    setShow(true);
  };

  useEffect(() => {
    if (!show) {
      setSelectedFiles([]);
      setExistingFiles(files || []);
    }
  }, [files, show]);

  const handleFileChange = (event) => {
    const nextFiles = Array.from(event.target.files || []);
    if (nextFiles.length) {
      setSelectedFiles((prev) => [...prev, ...nextFiles]);
    }
    event.target.value = "";
  };

  const removeExistingFile = (fileId) => {
    setExistingFiles((prev) =>
      prev.filter((file) => (file?.id || file?._id) !== fileId)
    );
  };

  const removeSelectedFile = (fileToRemove) => {
    setSelectedFiles((prev) => prev.filter((file) => file !== fileToRemove));
  };

  const { getFrontEndBranchList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <Button className="bg-thememain text-black m-1" onClick={handleShow}>
        {buttonTitle === "Quick Reply" ? (
          "Quick Reply Add"
        ) : (
          <i className="bi bi-pen-fill"></i>
        )}
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{popupTitle}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            setSaving(true);
            let attachmentIds = existingFiles
              .map((file) => file?.id || file?._id)
              .filter(Boolean);

            if (selectedFiles.length > 0) {
              const uploadResp = await dispatch(
                uploadFileInChat({ fileupload: selectedFiles })
              );

              if (uploadResp?.payload?.status) {
                const uploadedIds =
                  uploadResp?.payload?.uploads
                    ?.map((upload) => upload?.id)
                    .filter(Boolean) || [];
                attachmentIds = [...attachmentIds, ...uploadedIds];
              }
            }

            const apiResp = await dispatch(
              api({
                ...values,
                messageType: "text",
                attachments: attachmentIds,
              })
            );

            if (apiResp?.payload?.status) {
              resetForm({ values: "" });
              setSelectedFiles([]);
              setExistingFiles([]);
              handleClose();
              dispatch(getQuickReply());
            }
            setSaving(false);
          }}
          initialValues={{
            title,
            question,
            messageType: messageType || "text",
            content,
            orderBy,
            branch,
            id,
            suggestionfile,
            status,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            setFieldValue,
            errors,
          }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3 mt-2">
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Title"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      isInvalid={!!errors.title}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.title}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label>Question</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Question"
                      name="question"
                      value={values.question}
                      onChange={handleChange}
                      isInvalid={!!errors.question}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.question}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4} sm={12}>
                  <Form.Group>
                    <Form.Label>Reply Format</Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      value="Text with optional images"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group>
                    <Form.Label>Content</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={3}
                      placeholder="Content"
                      name="content"
                      value={values.content}
                      onChange={handleChange}
                      isInvalid={!!errors.content}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.content}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Images</Form.Label>
                    <Form.Control
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    <Form.Text className="text-muted">
                      You can save one message with text and multiple images together.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              {(existingFiles.length > 0 || selectedFiles.length > 0) && (
                <Row className="mb-3">
                  <Col md={12}>
                    <div className="quick-reply-files-grid">
                      {existingFiles.map((file) => {
                        const fileId = file?.id || file?._id;
                        return (
                          <div className="quick-reply-file-card" key={fileId}>
                            <img
                              src={file?.cloudUrl || file?.url}
                              alt={file?.originalName || "quick-reply-file"}
                            />
                            <button
                              type="button"
                              className="quick-reply-file-remove"
                              onClick={() => removeExistingFile(fileId)}
                            >
                              <i className="bi bi-x-lg"></i>
                            </button>
                          </div>
                        );
                      })}
                      {selectedFiles.map((file) => (
                        <div
                          className="quick-reply-file-card"
                          key={`${file.name}-${file.lastModified}`}
                        >
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                          />
                          <button
                            type="button"
                            className="quick-reply-file-remove"
                            onClick={() => removeSelectedFile(file)}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <Col md={4} sm={4}>
                  <Form.Group>
                    <Form.Label>OrderBy</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="OrderBy"
                      name="orderBy"
                      value={values.orderBy}
                      onChange={handleChange}
                      isInvalid={!!errors.orderBy}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.orderBy}
                    </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                {!isTeamLeader && (
                  <Col md={4}>
                    <Form.Label>Branch</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      isMulti
                      name="branch"
                      onChange={(selectedOptions) => {
                        setFieldValue(
                          "branch",
                          selectedOptions?.map((data) => data?.value) || []
                        );
                      }}
                      options={
                        getFrontEndBranchList?.map((data) => ({
                          value: data?.id,
                          label: data?.name,
                        })) || []
                      }
                      defaultValue={
                        !!branch &&
                        branch
                          ?.map((data) => {
                            if (values.branch?.indexOf(data) != -1) {
                              return {
                                value: data?.id,
                                label: data?.name,
                              };
                            }
                            return null;
                          })
                          ?.filter(Boolean)
                      }
                      classNamePrefix="react-select"
                    />
                    {touched.branch && errors.branch && (
                      <div className="text-danger mt-1">{errors.branch}</div>
                    )}
                  </Col>
                )}
                <Col md={4} sm={12}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={(e) => {
                        setFieldValue("status", /true/.test(e.target.value));
                      }}
                      name="status"
                      className="form-control"
                      value={values.status}
                      isInvalid={!!errors.status}
                    >
                      <option value="">Select Status</option>
                      <option value="true">Active</option>
                      <option value="false">InActive</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.status}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit" disabled={saving}>
                  {saving ? "Saving..." : "Submit"}
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default QuickReplyAction;
